function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudpanelLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M478 235.1c-18.5-21-43.6-36.6-72.1-44.8v-1.6c0-76.7-67.3-139.3-150.3-139.3-83.1 0-150.4 62.4-150.4 139.3v1.9C44.4 208.3 0 261.1 0 323.4c0 76.7 67.4 139.3 150.4 139.3 39.8-.1 78-14.5 105.7-40.1 27.6 25.6 65.7 40 105.5 40.1 82.8 0 150.4-62.4 150.4-139.3 0-32.1-12.2-63.5-34-88.3M361.6 427.5c-61.9 0-112.4-46.7-112.4-104.1.2-9.5-8.4-17.3-19-17.6-10.5.1-19 7.9-19 17.2v.4c0 26 7.8 50.4 21.2 71.3-20.8 20.9-50.7 32.9-82 33C88.4 427.7 38 381 38 323.6s50.5-104.1 112.4-104.1c13.4 0 26.5 2.2 39 6.4.2 0 .3.1.4.1 4.3 1.4 10.4 4 12.3 5.5 3.4 2.7 7.8 4.3 12.3 4.3 5.6 0 10.9-2.3 14.3-6.2 6.8-7.4 5.9-18.4-2.1-24.7-8.3-6.5-21.2-10.9-24.4-12-16.5-5.6-34.1-8.5-51.7-8.4-2.4 0-4.8 0-7.2.1 2.6-55.5 51.9-99.8 112.4-99.8 61.9 0 112.4 46.7 112.4 104.1.1 33.3-17.4 64.8-47.3 84.9-8.5 5.8-10.4 16.6-4.5 24.4 3.7 4.7 9.6 7.4 15.5 7.4 3.8 0 7.6-1 11-3.3 28.4-18.9 48.7-45.9 57.8-76.4 43.4 14.9 73.6 53.8 73.6 97.7-.1 57.2-50.5 103.9-112.6 103.9",
    style: {
      fill: "#0178d4"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudpanelLogo);
export default __webpack_public_path__ + "static/media/cloudpanel-logo.cb507473c89e65eb3bdf1ddacfcc40a2.svg";
export { ForwardRef as ReactComponent };